import { defineStore } from 'pinia';

export interface OrderState {
  order: Order | undefined;
}

export const useOrderStore = defineStore('order', {
  state: (): OrderState => ({
    order: undefined,
  }),

  getters: {
    confirmedItems(state): any[] {
      return state.order?.items || [];
    },
    confirmedOrder(state): Order | undefined {
      if (!state.order) return undefined;
      return state.order;
    },
  },

  actions: {
    setOrder(order: Order) {
      this.order = order;
    },
    async submitOrder(orderParams: SubmitOrder) {
      return useShopApi().submitOrder(orderParams);
    },
    async submitPaypalExpressOrder(orderParams: any) {
      return useShopApi().submitPaypalExpress(orderParams);
    },
    async setConfirmedOrder() {
      const data = await useShopApi().confirmOrder();
      this.setOrder(data.order);
      return data;
    },
  },
});
